// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2xVD3","subheader":"ReorderModal_subheader__26n2r","listWrap":"ReorderModal_listWrap__zywv2"};